"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouter = require("react-router");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MarginBalances = require("../../components/MarginBalances");
var _MarginTransferAssetsModal = _interopRequireDefault(require("../../components/MarginTransferAssetModal/MarginTransferAssetsModal"));
var _MarginDepositModalContainer = _interopRequireDefault(require("../../components/MarginBalances/MarginDepositWithdraw/MarginDepositModal/MarginDepositModalContainer"));
var _AccountsDropdownContainer = _interopRequireDefault(require("../../components/AccountsDropdown/AccountsDropdownContainer"));
require("./WalletsLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Wallets = function Wallets(_ref) {
  var isMarginEnabled = _ref.isMarginEnabled,
    isMarginSelected = _ref.isMarginSelected,
    marginAccountId = _ref.marginAccountId,
    spotAccountId = _ref.spotAccountId,
    getAccountMarginBalances = _ref.getAccountMarginBalances,
    getAccountBalances = _ref.getAccountBalances,
    getMarginProductsConfig = _ref.getMarginProductsConfig,
    isFuturesSelected = _ref.isFuturesSelected,
    futuresAccountId = _ref.futuresAccountId,
    getAccountFuturesBalances = _ref.getAccountFuturesBalances,
    getFuturesProducts = _ref.getFuturesProducts;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchText = _useState2[0],
    setSearchText = _useState2[1];
  var _useState3 = (0, _react.useState)(localStorage.getItem('hideMarginSmallAmounts') !== 'false'),
    _useState4 = _slicedToArray(_useState3, 2),
    isSmallAmountsChecked = _useState4[0],
    setisSmallAmountsChecked = _useState4[1];
  (0, _react.useEffect)(function () {
    if (isMarginSelected) {
      getAccountMarginBalances(marginAccountId);
      // Additional request below needed because this action stores both margin and spot balances in redux
      // Used by MarginTransferAssetsFormContainer for all account balances
      getAccountBalances(marginAccountId);
    }
  }, [isMarginSelected, marginAccountId, getAccountMarginBalances, getAccountBalances, isSmallAmountsChecked]);
  (0, _react.useEffect)(function () {
    !isMarginSelected && getAccountBalances(spotAccountId);
  }, [isMarginSelected, spotAccountId, getAccountBalances, isSmallAmountsChecked]);
  (0, _react.useEffect)(function () {
    if (isFuturesSelected) {
      getAccountFuturesBalances(futuresAccountId);
    }
  }, [isFuturesSelected, isSmallAmountsChecked, getAccountFuturesBalances, futuresAccountId]);
  (0, _react.useEffect)(function () {
    getMarginProductsConfig();
  }, [getMarginProductsConfig]);
  (0, _react.useEffect)(function () {
    getFuturesProducts();
  }, [getFuturesProducts]);
  var handleSmallAmountsToggle = function handleSmallAmountsToggle(nextValue) {
    setisSmallAmountsChecked(nextValue);
    localStorage.setItem('hideMarginSmallAmounts', nextValue);
  };
  var accountSummary;
  if (isMarginSelected) {
    accountSummary = /*#__PURE__*/_react["default"].createElement(_MarginBalances.MarginAccountSummaryContainer, {
      isMarginEnabled: isMarginEnabled
    });
  } else if (isFuturesSelected) {
    accountSummary = /*#__PURE__*/_react["default"].createElement(_MarginBalances.FuturesAccountSummaryContainer, null);
  } else {
    accountSummary = /*#__PURE__*/_react["default"].createElement(_MarginBalances.SpotAccountSummaryContainer, {
      isMarginEnabled: isMarginEnabled,
      spotAccountId: spotAccountId
    });
  }
  var balancesTable;
  if (isMarginSelected) {
    balancesTable = /*#__PURE__*/_react["default"].createElement(_MarginBalances.MarginBalancesTableContainer, {
      searchText: searchText
    });
  } else if (isFuturesSelected) {
    balancesTable = /*#__PURE__*/_react["default"].createElement(_MarginBalances.FuturesBalancesTablesWrapper, {
      searchText: searchText,
      onSearch: setSearchText,
      onHideSmallAmounts: handleSmallAmountsToggle,
      isSmallAmountsChecked: isSmallAmountsChecked
    });
  } else {
    balancesTable = /*#__PURE__*/_react["default"].createElement(_MarginBalances.SpotBalancesTableContainer, {
      searchText: searchText
    });
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "wallets-layout__header-container"
  }, /*#__PURE__*/_react["default"].createElement(_AccountsDropdownContainer["default"], {
    customClass: "page-wallet",
    showSelectedAccount: true
  }), accountSummary), !isFuturesSelected && /*#__PURE__*/_react["default"].createElement(_MarginBalances.MarginBalancesTableHeader, {
    searchText: searchText,
    onSearch: setSearchText,
    onHideSmallAmounts: handleSmallAmountsToggle,
    isSmallAmountsChecked: isSmallAmountsChecked
  }), balancesTable, /*#__PURE__*/_react["default"].createElement(_MarginTransferAssetsModal["default"], null), /*#__PURE__*/_react["default"].createElement(_MarginDepositModalContainer["default"], null));
};
Wallets.propTypes = {
  history: _propTypes["default"].object.isRequired,
  isMarginEnabled: _propTypes["default"].bool,
  isMarginSelected: _propTypes["default"].bool,
  marginAccountId: _propTypes["default"].number,
  getAccountMarginBalances: _propTypes["default"].func,
  getAccountBalances: _propTypes["default"].func,
  getMarginProductsConfig: _propTypes["default"].func,
  isFuturesSelected: _propTypes["default"].bool,
  futuresAccountId: _propTypes["default"].number,
  getAccountFuturesBalances: _propTypes["default"].func,
  getFuturesProducts: _propTypes["default"].func
};
var _default = exports["default"] = (0, _reactRouter.withRouter)(Wallets);